import { track } from '../analytics/index.esm.js';
import { WebsiteEvents } from '../constants/events.esm.js';
import { PerformanceMetricNameToTypeMap } from '../constants/performance.esm.js';
import { getCommonPayload } from './utils.esm.js';

const isNavigationTiming = (entry)=>{
    return 'entryType' in entry && entry.entryType === 'navigation';
};
const reportPerformanceStat = async (metric, pageInfo)=>{
    const eventName = PerformanceMetricNameToTypeMap[metric.name];
    if (!eventName) {
        return;
    }
    const commonPayload = getCommonPayload();
    const promises = [
        track(eventName, {
            value: round(metric.value, 2),
            delta: metric.delta ? round(metric.delta, 2) : metric.delta,
            rating: metric.rating,
            navigation_type: metric.navigationType,
            stat_id: metric.id,
            ...pageInfo || {},
            ...commonPayload
        })
    ];
    if (metric.entries?.length && eventName === PerformanceMetricNameToTypeMap.TTFB && isNavigationTiming(metric.entries[0])) {
        promises.push(reportPageLoading(metric.entries[0], commonPayload, pageInfo));
    }
    await Promise.all(promises);
};
const round = (value, decimals = 0)=>{
    const multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
};
const reportPageLoading = (entry, commonPayload, pageInfo)=>{
    return track(WebsiteEvents.WEBSITE_PERFORMANCE_PAGE_LOADING_MEASURED, {
        compression_ratio: entry.decodedBodySize ? round(1 - entry.encodedBodySize / entry.decodedBodySize, 2) : 0,
        decoded_body_size: entry.decodedBodySize,
        dns: round(entry.domainLookupEnd - entry.domainLookupStart),
        dom_content_loaded: round(entry.loadEventEnd - entry.loadEventStart),
        dom_processing: round(entry.domComplete - entry.domInteractive),
        encoded_body_size: entry.encodedBodySize,
        header_size: entry.transferSize ? entry.transferSize - entry.encodedBodySize : 0,
        redirection: round(entry.redirectEnd - entry.redirectStart),
        ssl: entry.secureConnectionStart ? round(entry.connectEnd - entry.secureConnectionStart) : 0,
        tcp: round(entry.connectEnd - entry.connectStart),
        total_duration: round(entry.duration),
        transfer_size: entry.transferSize,
        transferring: round(entry.responseEnd - entry.responseStart),
        ttfb: round(entry.responseStart - entry.requestStart),
        ...pageInfo || {},
        ...commonPayload
    });
};

export { reportPerformanceStat };
